export default __webpack_public_path__ + "static/media/karibu.6067b8ae.jpg";